<template>
  <div class="a7-dashboard">
    <div class="card-list">
      <gw-card class="card-filter-band">
        <gw-filter-band slot="body" v-model="filterParams">
          <a7-unidade-negocio-filter-item
            :display-text="$t('A7Dashboard.ui.filtroUnidadeNegocio')"
            property-name="unidadesNegocio"/>
          <gw-text-filter-item
            :display-text="$t('A7Dashboard.ui.filtroGrupoClienteAlpha7')"
            property-name="grupoClienteAlpha7"/>
        </gw-filter-band>
      </gw-card>
      <slot/>
    </div>
  </div>
</template>

<script>
import {
  GwCard,
  GwFilterBand,
  GwTextFilterItem
} from 'guaxinim-web';
import A7UnidadeNegocioFilterItem from '../unidadeNegocio/A7UnidadeNegocioFilterItem';

export default {
  name: 'a7-dashboard',
  components: {
    GwCard,
    GwFilterBand,
    GwTextFilterItem,
    A7UnidadeNegocioFilterItem
  },
  data() {
    return {
      filterParams: {}
    }
  },
  methods: {
    emitFilterParams() {
      this.$emit('filterParams', this.filterParams);
    }
  },
  watch: {
    filterParams: {
      deep: true,
      handler() {
        this.emitFilterParams();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'guaxinim-web/src/css/MediaBreakpoints.scss';

.a7-dashboard {
  height: 100%;
  background-color: #ededed;
  padding: 4px;
  overflow-y: auto;

  .card-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    grid-gap: 2px;
    align-items: stretch;

    .card-filter-band {
      grid-column: 1 / -1;
      z-index: 15;
    }

    @include sm {
      grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    }
  }
}
</style>
